export const stepperMobileStyles = {
  titlesContainer: {
    width: "100%",
    position: "relative" as const,
  },
  titleWrapper: {
    position: "absolute" as const,
    top: 0,
    transform: "translateX(-50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap" as const,
  },
  dotsContainer: {
    width: "100%",
    height: "12px",
    flexDirection: "row" as const,
    alignItems: "center",
    justifyContent: "space-between",
    position: "relative" as const,
    zIndex: 0,
  },
  trackContainer: {
    position: "absolute" as const,
    top: "50%",
    left: "6px",
    right: "6px",
    height: "3px",
    transform: "translateY(-50%)",
    zIndex: 1,
  },
  connectorSegment: {
    position: "absolute" as const,
    top: 0,
    bottom: 0,
    transition: "background 0.2s",
  },
  stepIndicatorWrapper: {
    position: "relative" as const,
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "12px",
    height: "12px",
  },
  stepText: {
    fontSize: "$xs",
    textAlign: "center" as const,
    whiteSpace: "nowrap" as const,
    transition: "color 0.2s",
    userSelect: "none" as const,
  },

  stepIndicator: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s",
  },
};

export const getMobileStepStyles = (
  index: number,
  activeStep: number,
  allowNavigation: boolean,
) => {
  const isActive = index === activeStep;
  const isCompleted = index < activeStep;
  const isClickable = allowNavigation && (isCompleted || isActive);

  return {
    textColor: isActive || isCompleted ? "$neutral-600" : "$neutral-500",
    fontWeight: isActive || isCompleted ? 600 : 400,
    cursor: isClickable ? "pointer" : "default",
    indicatorBackground: isActive ? "$primary-light" : isCompleted ? "$primary-600" : "white",
    indicatorBorder: isActive || isCompleted ? "$primary-600" : "$neutral-400",
    connectorRightBackground:
      index < activeStep ? "$primary-600" : index === activeStep ? "$primary-200" : "$neutral-300",
  };
};
